<!--SKU编辑  -->
<template>
	<div class="dialogBox">
		<el-dialog title="合并客商" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="1100px" :before-close="cancle" top="3vh">
			<div class="merge-box">
				<el-button  size="small"   @click="addRow">插入</el-button>
				<el-button  size="small"   @click="handleAllDelete">删除</el-button>

					<el-table :data="tableMergeData" class="mt10"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333',height:'25px'}" border @selection-change="handleSelectionChange"
					style="width: 100%">
					<el-table-column type="selection" width="55">
					</el-table-column>
					 <!-- type="index" -->
					<el-table-column type="index" label="序号"  width="70">
					</el-table-column>
					<el-table-column :show-overflow-tooltip="true">
						 <template slot="header" slot-scope="scope">
							客商编号
							<i class="el-icon-search ml10" @click="handleAddMerge(1)"></i>
						</template>
						<template slot-scope="scope">
							<div class="flex flex-between">
								<div>
									{{scope.row.agentCode}}
								</div>
								<div class="lh30">
									<i class="el-icon-remove-outline ml10 fr" @click="handleDelete(scope.$index)"></i>
									<i class="el-icon-search fr " @click="handleAddMerge(1,scope.$index)"></i>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="agentName" label="客商名称"  :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="sapNo" label="客商SAP编号"  :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div class="flex flex-between">
								<div>
									{{scope.row.sapNo}}
								</div>
								<div class="lh30">
									<i class="el-icon-remove-outline ml10 fr" @click="handleDeleteNc(scope.$index)"></i>
									<i class="el-icon-search fr" @click="handleAddMerge(2,scope.$index)"></i>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="ncAgentCode" label="SAP客商编号"  :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="ncAgentName" label="SAP客商名称"  :show-overflow-tooltip="true">
					</el-table-column>
				</el-table>
			</div>

			<span slot="footer" class="dialog-footer mt10">
				<el-button  size="small" @click="cancle()">取 消</el-button>
				<el-button  size="small" type="primary" @click="submitForm()">合并</el-button>
			</span>
		</el-dialog>
		<addMerchants ref="addMerchants" @selectRows="selectRows" @selectNewFlag="selectNewFlag"></addMerchants>
	</div>
</template>

<script>
	import addMerchants from './add-merchants.vue'
	import {
		debounce
	} from '@/utils/debounce'
	export default {
		components: {
			addMerchants
		},
		data() {
			return {
				dialogVisible: false,
				agentIds: [],
				tableData: [],
				sapNo: "",
				tableData1: [],
				multipleSelection: [],
				settlementType: {
					0: '现金',
					1: '账期',
					2: '其它',
					'9': '自贩'
				},
				otherTable: [], //临时table,
				tableMergeData:[],
				No:-1,
				ncNo:-1,
			}
		},
		created() {

		},
		methods: {
			init(tree, data) {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.tableData = []
					this.tableData1 = []
					this.tableMergeData=[]
				})
			},
			//  添加客商信息
			handleAddMerge(val,index) {
				// 整体数据
				if (index==undefined&& this.tableMergeData.length >= 10) {
					this.$message.error('只能添加10条源客商!');
					return
				}

				val == 1 ? this.No=index:this.ncNo=index
				this.$refs.addMerchants.init(this.tableMergeData, val == 1 ? "Y" : "N")
			},
			// 添加一行
			addRow(){
				if (this.tableMergeData.length >= 10) {
				this.$message.error('只能添加10条数据!');
				return
				}
				this.tableMergeData.push({
					index:this.tableMergeData.length+1,
					agentCode:"",
					agentName:"",
					ncAgentCode:"",
					ncAgentName:"",
					agentId:"",
					sapNo:"",
				})
			},
			// 删除整行
			handleAllDelete(){

				this.multipleSelection.forEach(item => {
					this.tableMergeData.forEach((item1,i,arr) => {
						if(item.index==item1.index){
							 arr.splice(i, 1); //删除下标为i的元素
							// this.tableMergeData.splice(i,1)
						}
					});
				});
				this.$forceUpdate()
			},

			// 删除目标客商
			handleDeleteNc(index) {
				this.tableMergeData[index].ncAgentCode = ""
				this.tableMergeData[index].ncAgentName = ""
				this.tableMergeData[index].sapNo = ""
			},
			// 列多选
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 删除
			handleDelete(index) {
				this.tableMergeData[index].agentCode = ""
				this.tableMergeData[index].agentName = ""
				this.tableMergeData[index].agentId = ""
			},
			// 选择的客商信息
			selectRows(val) {
				this.otherTable = val
			},
			// 判断是哪个表返回的数据
			selectNewFlag(val) {

				if (val == "Y") {
					// 源客商
					// this.tableData = this.unRepeat(this.otherTable, this.tableData)
					if(this.No>=0&&this.otherTable.length==1&&this.tableMergeData.length>0){
						this.tableMergeData[this.No].agentCode=this.otherTable[0].agentCode
						this.tableMergeData[this.No].agentName=this.otherTable[0].agentName
						this.tableMergeData[this.No].agentId=this.otherTable[0].agentId
					}else{
						this.otherTable.forEach((item,index) => {
							this.tableMergeData.push({
									index:this.tableMergeData.length+1,
									agentCode:item.agentCode,
									agentName:item.agentName,
									ncAgentCode:"",
									ncAgentName:"",
									agentId:item.agentId,
									sapNo:"",
							})
						});
					}
				} else {
					// 目标客商
					// this.tableData1 = this.otherTable
					if(this.otherTable.length==1&&this.tableMergeData.length>0){
						this.tableMergeData[this.ncNo].ncAgentCode=this.otherTable[0].agentCode
						this.tableMergeData[this.ncNo].ncAgentName=this.otherTable[0].agentName
						this.tableMergeData[this.ncNo].sapNo=this.otherTable[0].sapNo
					}else{
						this.otherTable.forEach((item,index) => {
							this.tableMergeData.push({
									index:this.tableMergeData.length+1,
									agentCode:"",
									agentName:"",
									ncAgentCode:item.agentCode,
									ncAgentName:item.agentName,
									agentId:"",
									sapNo:item.sapNo,
							})
						});
					}
				}
			},
			// 去重
			unRepeat(json1, json2) {
				let json = json1.concat(json2); //两个数组对象合并
				// console.log(json)
				let newJson = []; //盛放去重后数据的新数组
				json.forEach(item1 => {
					let flag = true; //建立标记，判断数据是否重复，true为不重复
					newJson.forEach(item2 => {
						if (item1.index == item2.index) { //让json数组对象的内容与新数组的内容作比较，相同的话，改变标记为false
							flag = false;
						}
					});
					if (flag) { //判断是否重复
						newJson.push(item1); //不重复的放入新数组。  新数组的内容会继续进行上边的循环。
					}
				});
				return newJson
			},
			// 保存
			submitForm: debounce(function () {
				let that = this;
				let isNull = false
				if(this.tableMergeData.length<=0){
					this.$message.error('请选择客商数据!');
					return
				}
				this.tableMergeData.some(item => {
					if(!item.agentId||!item.sapNo){
						isNull = true
						return !item.agentId // 当有数组有一项满足条件时结束并返回true
					}
				})
				if(isNull){
					this.$message.error('源客商和目标需要一一对应且不能都为空!');
					return
				}
				let agentIds = []
				that.tableMergeData.forEach((item,index) => {
					agentIds.push({agentId:item.agentId,sapNo:item.sapNo})
				});

				that.$confirm('确认要合并客商，把临时客商的销售订单转移给目标客商吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.$request.post(
							"agentMergeAgent",
							true, {
								agents: agentIds,
								// sapNo: that.tableData1[0].sapNo,
							}
						)
						.then((res) => {
							if (res) {
								that.dialogVisible = false
								that.$message.success("合并成功！");
								that.$emit("getList")
							}
						})
				}).catch(() => {});
			}, 1000, true),
			// 取消
			cancle() {
				this.dialogVisible = false
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.dialogBox {

		/deep/ .el-dialog__body {
			padding: 15px;
		}

		.el-table {

			// 深度选择器，去除默认的padding
			/deep/ th {
				padding: 5px;
			}

			/deep/ td {
				padding: 5px;
			}
		}

		.el-divider--horizontal {
			margin: 15px 0;
		}
	}

	.icon-size {
		font-size: 16px;
		i{
			cursor: pointer;
		}
	}
.el-icon-circle-plus-outline{
	cursor: pointer;
}
.el-icon-remove-outline{
	cursor: pointer;
}
.el-icon-search{
	cursor: pointer;
}
.merge-box{
	min-height: 370px;
}
.lh30{
	margin-top: 6px;
}
</style>
